<template>
  <div class="step review-step">
    <h3>Hang tight, <br> reviewing your regimen</h3>
    <div class="image">
      <img :src="getImageUrl('/images/icons/cla.png')">
      <div class="review-text">
        <p>Reviewing existing profile info ...</p>
        <p v-if="matching">Matching preferences ...</p>
        <p v-if="preparing">Preparing results ...</p>
      </div>
    </div>
  </div>
</template>
<script>
import profileMixin from "@/mixins/profileMixin";

export default {
    mixins: [profileMixin],

    data: () => ({
        matching: false,
        preparing: false
    }),

    created() {
        this.loadProgress()
    },

    methods: {
        loadProgress() {
            setTimeout(() => {
                this.loadMatching();
            }, 1000);
        },

        loadMatching() {
            this.matching = true

            setTimeout(() => {
                this.loadPreparing();
            }, 1000);
        },

        loadPreparing() {
            this.preparing = true

            setTimeout(() => {
                this.$emit('nextStep');
            }, 1000);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/RegimenChecker/steps/ReviewStep.vue